import { defineMessages } from 'react-intl';

export default defineMessages({
  somethingWentWrong: {
    id: 'somethingWentWrong',
    defaultMessage: 'Something went wrong',
  },
});
